import React, { useEffect, useState } from "react";

import {
  faDownload,
  faFilter,
  faPlus,
  faPlusCircle,
  faRetweet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useSelector } from "react-redux";
import { Pagination } from "../../../Components/Pagination";
import XLSX from "xlsx-js-style";
import { Checkbox, styled } from "@mui/material";

export default function LichSuXacNhanGiaoHangERP() {
  const { lang, proxy } = useSelector((s) => s);
  const [data, setData] = useState([]);
  const token = localStorage.getItem("_token");

  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState();
  const [refresh, setRefresh] = useState(0);
  const [refreshModal, setRefreshModal] = useState(0);
  const [search, setSearch] = useState({});
  const [openFilterDate, setOpenFilterDate] = useState({});
  const [openCollapseData, setOpenCollapseData] = useState({});
  const [loading, setLoading] = useState(true);

  const dataPerPage = 15;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data;
  //&& data.slice(indexOfFirstData, indexOfLastData);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSearch((prev) => ({
      ...prev,
      page: pageNumber,
    }));
  };
  const [exportFields, setExportFields] = useState([
    //   {
    //     field: "idLogsPXKXN",
    //     value: null,
    //     isUnique: false,
    //     isCondition: false,
    //     label: "",
    //   },
    {
      field: "maphieuxuatkho",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Phiếu Xuất Kho",
    },
    {
      field: "maphieuxuatkhos",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Mã Phiếu Xuất Kho ERP",
    },
    {
      field: "ngayxuat",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Ngày Xuất",
      type: "date",
    },
    {
      field: "tenphuongtien",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Tên Phương Tiện",
    },
    {
      field: "sttxetau",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Số Thứ Tự Xe Tàu",
    },
    {
      field: "biensoxetau",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Biển Số Xe Tàu",
    },
    {
      field: "chuxetau",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Chủ Xe Tàu",
    },
    {
      field: "daidienbocxep",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Đại Diện Bốc Xếp",
    },
    {
      field: "nguoinhan",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Người Nhận",
    },
    {
      field: "lenhxuathang",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Lệnh Xuất Hàng",
    },
    {
      field: "nguoitaophieu",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Người Tạo Phiếu",
    },
    {
      field: "taiKhoanThietBiLogsPXKXN",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Tài Khoản Thiết Bị",
    },
    {
      field: "taiKhoanNguoiDungLogsPXKXN",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Người Cập Nhật",
    },
    {
      field: "ngayDongBoLogsPXKXN",
      value: null,
      isUnique: false,
      isCondition: false,
      label: "Ngày Đồng Bộ",
      type: "date",
    },
    //   {
    //     field: "actionLogsPXKXN",
    //     value: null,
    //     isUnique: false,
    //     isCondition: false,
    //     label: "",
    //   },
    //   {
    //     field: "dataLogsPXKXN",
    //     value: null,
    //     isUnique: false,
    //     isCondition: false,
    //     label: "Data",
    //   },
  ]);
  const [selected, setSelected] = useState(
    exportFields.map(() => ({ isChecked: false }))
  );

  useEffect(() => {
    setLoading(true);
    // fetch`http://192.168.15.204:5008/api/SyncERP/Search/PhieuXuatKho`, {
    fetch(proxy() + `/api/SyncERP/Search/PhieuXuatKhoConfirm`, {
      // fetch(`http://192.168.15.204:5008/api/SyncERP/Search/PhieuXuatKhoConfirm`, {
      method: "POST",
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify(search),
    })
      .then((res) => res.json())
      .then((res) => {
        const { result, total } = res;
        setTotal(total);
        setData(result);
      })
      .finally(() => setLoading(false));
  }, [search, refresh]);

  const findArray =
    currentData &&
    headers.find((h) => currentData.some((d) => Array.isArray(d[h.key])));

  const handleExport = (data) => {
    // fetch(`http://192.168.15.204:5008/api/SyncERP/Export/PhieuXuatKho`, {
    fetch(proxy() + `/api/SyncERP/Export/PhieuXuatKhoConfirm`, {
      method: "POST",
      headers: {
        Authorization: token,
        "content-type": "application/json",
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      body: JSON.stringify({
        export_fields: data.filter((item) => item?.isChecked),
      }),
    })
      .then((response) => response.body)
      .then((rb) => {
        const reader = rb.getReader();

        return new ReadableStream({
          start(controller) {
            function push() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                  return;
                }
                controller.enqueue(value);
                push();
              });
            }

            push();
          },
        });
      })
      .then((stream) =>
        new Response(stream, {
          headers: { "content-type": "application/json" },
        }).blob()
      )
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        const currentTime = moment().format("YYYY-MM-DD HH:mm");

        a.download = `DATA_LichSuPhieuXuatKho_${currentTime}.xlsx`;

        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((error) => {
        console.error("Error during export:", error);
      })
      .finally(() => setRefreshModal((prev) => prev + 1));
  };
  const isCheckedAll = exportFields.every((item) => item.isChecked);
  const handleChecked = (index, isCheckAll) => {
    if (isCheckAll) {
      const checkedState = !isCheckedAll;

      setSelected(exportFields.map(() => ({ isChecked: checkedState })));

      setExportFields((prev) =>
        prev.map((item) => ({
          ...item,
          isChecked: checkedState,
        }))
      );
    } else {
      setSelected((prev) => {
        const newSelected = [...prev];
        newSelected[index] = {
          isChecked: !(prev[index]?.isChecked ?? false),
        };
        return newSelected;
      });
      setExportFields((prev) => {
        const newPrev = [...prev];
        newPrev[index] = {
          ...newPrev[index],
          isChecked: !(prev[index]?.isChecked ?? false),
        };
        return newPrev;
      });
    }
  };
  return (
    <div className="container-fluid">
      <div className="row" style={{ margin: "5px -15px" }}>
        <div className="col-md-12">
          <div className="white_shd full">
            <div className="tabbar padding_infor_info_p-d-5">
              <div>
                <div
                  className="d-flex align-items-center page-title position-relative mb-0"
                  style={{
                    padding: "13px 0px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "18px",
                      //   color: "rgb(68, 161, 161)",
                    }}
                  >
                    LỊCH SỬ SHIP HÀNG
                  </span>
                  <div className="ml-auto d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faDownload}
                      //   onClick={() => buildExportExcelFromLogs(headers, data)}
                      className="icon-add mr-2 pointer"
                      fontSize={2}
                      style={{
                        color: "#269c1b",
                      }}
                      data-toggle="modal"
                      data-target="#modalExport"
                    />
                    <FontAwesomeIcon
                      icon={faRetweet}
                      className="icon-add mr-2 pointer"
                      fontSize={2}
                      style={{
                        color: "rgb(224, 118, 42)",
                      }}
                      onClick={() => {
                        setRefresh((prev) => prev + 1);
                        setSearch({});
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <hr
                  style={{
                    border: "1px solid rgb(221, 221, 221)",
                    margin: "0px -11px 5px",
                  }}
                />
                <div className="table-display d-flex">
                  <div className="table-responsive table-custom design-table _table-custom">
                    <table bordered className="align-center" key={refresh}>
                      <thead>
                        <tr>
                          {findArray && <td></td>}
                          <td>#</td>
                          {headers.map((item) =>
                            item.type && item.type == "date" ? (
                              <th
                                style={{
                                  position: "sticky",
                                  zIndex: 9,
                                  top: "-1px",
                                }}
                              >
                                <div className="d-flex justify-content-between">
                                  {item.label}
                                  <span>
                                    <FontAwesomeIcon
                                      icon={faFilter}
                                      color="#34a83e"
                                      fontSize={14}
                                      onClick={() => {
                                        setOpenFilterDate((prev) => ({
                                          ...prev,
                                          [item.key]: !openFilterDate[item.key],
                                        }));
                                      }}
                                    />
                                  </span>
                                </div>
                                {openFilterDate[item.key] && (
                                  <div
                                    className="position-absolute"
                                    style={{
                                      zIndex: 999,
                                      width: "250px",
                                    }}
                                  >
                                    <div
                                      className="card"
                                      style={{
                                        borderRadius: ".25rem",
                                      }}
                                    >
                                      <div className="card-body">
                                        <div className="d-flex flex-column">
                                          <div
                                            className="start"
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            <label>Ngày bắt đầu</label>
                                            <input
                                              type="date"
                                              className="form-control"
                                              onChange={(e) => {
                                                const fromDate = e.target.value;
                                                setSearch((prev) => ({
                                                  ...prev,
                                                  [item.key]: {
                                                    ...(prev[item.key] || {}),
                                                    from: fromDate,
                                                  },
                                                }));
                                              }}
                                              value={
                                                search[item.key]?.from || ""
                                              }
                                            />
                                          </div>
                                          <div
                                            className="end"
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            <label className="text-left">
                                              Ngày kết thúc
                                            </label>
                                            <input
                                              type="date"
                                              className="form-control"
                                              onChange={(e) => {
                                                const toDate = e.target.value;
                                                setSearch((prev) => ({
                                                  ...prev,
                                                  [item.key]: {
                                                    ...(prev[item.key] || {}),
                                                    to: toDate,
                                                  },
                                                }));
                                              }}
                                              value={search[item.key]?.to || ""}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </th>
                            ) : (
                              !item?.isHidden && <td>{item.label}</td>
                            )
                          )}
                          {/* <td>Thao tác</td> */}
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td></td>
                          {findArray && <td></td>}
                          {headers.map((item, index) => {
                            return (
                              !item.isHidden && (
                                <td>
                                  <input
                                    className="form-control"
                                    type={item.type}
                                    onChange={(e) =>
                                      setSearch((prev) => {
                                        const { value } = e.target;
                                        return {
                                          ...prev,
                                          [item.key]:
                                            item.type === "date"
                                              ? {
                                                  from: moment()
                                                    .startOf("day")
                                                    .format("YYYY-MM-DD"),
                                                  to: value,
                                                }
                                              : value.trim(),
                                        };
                                      })
                                    }
                                  />
                                </td>
                              )
                            );
                          })}
                        </tr>

                        {loading ? (
                          <tr>
                            <td colSpan={99} style={{ textAlign: "center" }}>
                              <img
                                width={40}
                                src="/images/icon/load.gif"
                                alt="Loading..."
                              />
                            </td>
                          </tr>
                        ) : currentData && currentData.length ? (
                          currentData.map((item, index) => {
                            return (
                              <>
                                <tr key={index}>
                                  {findArray ? (
                                    <>
                                      <td>
                                        <img
                                          src={
                                            openCollapseData?.[item?.key]?.[
                                              index
                                            ]
                                              ? `/images/detail_minus.svg`
                                              : `/images/detail_plus.svg`
                                          }
                                          width={20}
                                          height={20}
                                          onClick={() =>
                                            setOpenCollapseData((prev) => ({
                                              ...prev,
                                              [item.key]: {
                                                [index]:
                                                  !openCollapseData?.[
                                                    item.key
                                                  ]?.[index],
                                              },
                                            }))
                                          }
                                        />
                                      </td>
                                      <td>
                                        <span>
                                          {indexOfFirstData + index + 1}
                                        </span>
                                      </td>
                                    </>
                                  ) : (
                                    <td>{indexOfFirstData + index + 1}</td>
                                  )}
                                  {headers.map(
                                    (field, idx) =>
                                      !field.isHidden && (
                                        <>
                                          <td key={idx}>
                                            {field.type === "date" &&
                                            item[field.key] ? (
                                              moment(item[field.key])
                                                .utc()
                                                .format("DD/MM/YYYY HH:mm:ss")
                                            ) : field.type === "array" &&
                                              Array.isArray(item[field.key]) ? (
                                              <ul
                                                style={{
                                                  paddingLeft: "1rem",
                                                  marginBottom: 0,
                                                }}
                                              >
                                                {/* {item[field.key].map(
                                                (childItem, i) => (
                                                  <li key={i}>
                                                    {field.childs
                                                      ?.map(
                                                        (child) =>
                                                          `${
                                                            child.label ||
                                                            child.key
                                                          }: ${
                                                            childItem[child.key]
                                                          }`
                                                      )
                                                      .join(" | ")}
                                                  </li>
                                                )
                                              )} */}
                                              </ul>
                                            ) : (
                                              item[field.key]
                                            )}
                                          </td>
                                        </>
                                      )
                                  )}
                                </tr>
                                {openCollapseData?.[item.key]?.[index] && (
                                  <tr>
                                    <td colSpan={headers.length + 2}>
                                      <div className="fold-content">
                                        <table className="table w-100 m-0 p-2 table">
                                          <thead>
                                            <tr>
                                              {headers
                                                .filter((h) => h.childs)
                                                .flatMap((header) =>
                                                  header.childs.map((child) => (
                                                    <td key={child.key}>
                                                      {child.label}
                                                    </td>
                                                  ))
                                                )}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item?.[findArray?.key]?.length >
                                              0 &&
                                              item[findArray.key].map(
                                                (childItem, i) => (
                                                  <tr key={`row-${i}`}>
                                                    {findArray.childs.map(
                                                      (child, j) => (
                                                        <td
                                                          key={`cell-${i}-${j}`}
                                                          style={{
                                                            textAlign:
                                                              j === 0 ||
                                                              j === 4 ||
                                                              j === 5
                                                                ? "left"
                                                                : "",
                                                          }}
                                                        >
                                                          {child.key === "stt"
                                                            ? childItem[
                                                                "status"
                                                              ] ||
                                                              item?.[
                                                                "status"
                                                              ]?.trim() != "200"
                                                              ? "false"
                                                              : "true"
                                                            : childItem[
                                                                child.key
                                                              ] ||
                                                              item[child.key]}
                                                          {`\n${
                                                            childItem?.[
                                                              child?.isChild
                                                            ] || ""
                                                          }`}
                                                        </td>
                                                      )
                                                    )}
                                                  </tr>
                                                )
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </>
                            );
                          })
                        ) : (
                          <td
                            className="align-center font-weight-bold"
                            colSpan={20}
                          >
                            {lang["not found"]}
                          </td>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    total={total}
                    itemsPerPage={dataPerPage}
                    currentPage={currentPage}
                    paginate={paginate}
                    lang={lang}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="modalExport"
        // tabindex="-1"
        // aria-labelledby="exampleModalLabel"
        // aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header d-flex align-items-center">
              <h5
                className="w-100"
                style={{
                  color: "#44a1a1",
                  fontSize: "18px",
                  padding: "6px 0px",
                }}
              >
                {/* Thống kê Nhập - Xuất Công Ty Vùng Miền */}
              </h5>
            </div>
            <div
              class="modal-body"
              style={{
                height: "60vh",
                overflow: "auto",
              }}
            >
              <form key={refreshModal}>
                <h5 class="mt-2 mb-2">{lang["select fields"]}:</h5>
                <div
                  className="select-all-checkbox"
                  style={{
                    maxWidth: "240px",
                    maxHeight: "40px",
                    margin: "15px 0px",
                  }}
                >
                  <label style={{ display: "flex" }}>
                    <Checkbox
                      key="all"
                      sx={{
                        "&:hover": { bgcolor: "transparent" },
                        margin: 0,
                        padding: 0,
                      }}
                      checked={isCheckedAll}
                      onChange={(e) => {
                        handleChecked("", true);
                      }}
                    />
                    <span className="ml-2 font-weight-bold">
                      {lang["selectall"]}
                    </span>
                  </label>
                </div>
                <>
                  <div
                    className="table-responsive table-custom design-table"
                    style={{ height: "auto" }}
                  >
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="header-filter">
                            {lang["field name"]}
                          </th>
                          <th className="header-filter">
                            {lang["select_export_condition"]}
                          </th>
                          {/* <th
                              className="header-filter"
                              colSpan={2}
                            >
                              {lang["conditions"]}
                            </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {exportFields?.map((item, index) => {
                          const BpIcon = styled("span")(({ theme }) => ({
                            borderRadius: 3,
                            width: 15,
                            height: 15,
                            boxShadow:
                              theme.palette.mode === "dark"
                                ? "0 0 0 1px rgb(16 22 26 / 40%)"
                                : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
                            backgroundColor:
                              theme.palette.mode === "dark"
                                ? "#394b59"
                                : "#f5f8fa",
                            backgroundImage:
                              theme.palette.mode === "dark"
                                ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
                                : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
                            ".Mui-focusVisible &": {
                              outline: "2px auto rgba(19,124,189,.6)",
                              outlineOffset: 2,
                            },
                            "input:hover ~ &": {
                              backgroundColor:
                                theme.palette.mode === "dark"
                                  ? "#30404d"
                                  : "#ebf1f5",
                            },
                            "input:disabled ~ &": {
                              boxShadow: "none",
                              background:
                                theme.palette.mode === "dark"
                                  ? "rgba(57,75,89,.5)"
                                  : "rgba(206,217,224,.5)",
                            },
                          }));

                          return (
                            <tr key={index}>
                              <td>
                                <div className="d-flex align-items-center">
                                  <Checkbox
                                    key={item.label}
                                    sx={{
                                      "&:hover": {
                                        bgcolor: "transparent",
                                      },
                                      margin: 0,
                                      padding: 0,
                                    }}
                                    // value={item?.checked}
                                    checked={selected?.[index]?.isChecked}
                                    onChange={(e) => {
                                      handleChecked(index);
                                    }}
                                  />

                                  <span className="ml-2">{item.label}</span>
                                </div>
                              </td>
                              <td>
                                {item.type === "date" ? (
                                  <>
                                    <div class="mb-2">
                                      <label class="form-label">
                                        Ngày bắt đầu
                                      </label>
                                      <input
                                        type="date"
                                        class="form-control w-50"
                                        onChange={(e) => {
                                          const { value } = e.target;

                                          setExportFields((prev) => {
                                            const newPrev = [...prev];

                                            newPrev[index] = {
                                              ...newPrev[index],
                                              value: {
                                                from: value.trim(),
                                                ...newPrev[index]?.value,
                                              },
                                            };

                                            return newPrev;
                                          });
                                        }}
                                      />
                                    </div>
                                    <div class="mb-2">
                                      <label class="form-label">
                                        Ngày kết thúc
                                      </label>
                                      <input
                                        type="date"
                                        class="form-control w-50"
                                        onChange={(e) => {
                                          const { value } = e.target;

                                          setExportFields((prev) => {
                                            const newPrev = [...prev];

                                            newPrev[index] = {
                                              ...newPrev[index],
                                              value: {
                                                ...newPrev[index]?.value,
                                                to: value.trim(),
                                              },
                                            };

                                            return newPrev;
                                          });
                                        }}
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => {
                                      const { value } = e.target;

                                      setExportFields((prev) => {
                                        const newPrev = [...prev];

                                        newPrev[index] = {
                                          ...newPrev[index],
                                          value: value.trim(),
                                        };

                                        return newPrev;
                                      });
                                    }}
                                  />
                                )}
                              </td>
                              {/* <td>
                                  <div className="d-flex align-items-center">
                                    <Checkbox
                                      sx={{
                                        "&:hover": {
                                          bgcolor: "transparent",
                                        },
                                        margin: 0,
                                        padding: 0,
                                      }}
                                      //   value=""
  
                                      onChange={(e) => {}}
                                    />
  
                                    <span className="ml-2">Trường Điều Kiện</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <Checkbox
                                      sx={{
                                        "&:hover": {
                                          bgcolor: "transparent",
                                        },
                                        margin: 0,
                                        padding: 0,
                                      }}
                                      //   value=""
  
                                      onChange={(e) => {}}
                                    />
  
                                    <span className="ml-2">Trường Cập Nhật</span>
                                  </div>
                                </td> */}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                // data-dismiss="modal"/
                style={{
                  background: "#1ed085",
                  border: "#1ed085",
                }}
                onClick={() => handleExport(exportFields)}
              >
                {lang["export"]}
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                style={{
                  background: "#dc3545",
                  border: "#dc3545",
                }}
                onClick={() => {
                  setRefreshModal((prev) => prev + 1);

                  setSelected(exportFields.map(() => ({ isChecked: false })));

                  setExportFields((prev) =>
                    prev.map((item) => ({
                      ...item,
                      isChecked: false,
                      value: null,
                    }))
                  );
                }}
              >
                {lang["btn.close"]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const headers = [
  { label: "Phiếu Xuất Kho", key: "phieuxuatkhosaas", type: "text" },
  { label: "Phiếu Xuất Kho ERP", key: "maphieuxuatkho", type: "text" },
  {
    label: "Data",
    key: "dataLogsPXKXN",
    type: "array",
    isHidden: true,
    childs: [
      {
        label: "Mã Sản Phẩm",
        key: "masanpham",
        isChild: "tensanpham",
      },
      {
        label: "SL Tấn Xuất Thực Tế",
        key: "soluongtanxuatthucte",
      },
      {
        label: "Đơn Vị Tính",
        key: "donvitinh",
      },
      {
        label: "Solot",
        key: "solot",
      },
      {
        label: "Kho Con",
        key: "khocon",
        isChild: "tenkho",
      },
      {
        label: "Vị Trí Trong Kho",
        key: "vitritrongkho",
        isChild: "tenvitritrongkho",
      },
      {
        label: "Errorcode",
        key: "status",
      },
      {
        label: "Trạng Thái",
        key: "stt",
      },
      {
        label: "Mô Tả",
        key: "message",
      },
    ],
  },
  //   { label: "Mã Phiếu Xuất Kho ERP", key: "maphieuxuatkho", type: "text" },
  { label: "Ngày Xuất", key: "ngayxuat", type: "date" },
  { label: "Tên Phương Tiện", key: "tenphuongtien", type: "text" },
  { label: "Số Thứ Tự Xe Tàu", key: "sttxetau", type: "text" },
  { label: "Biển Số Xe Tàu", key: "biensoxetau", type: "text" },
  { label: "Chủ Xe Tàu", key: "chuxetau", type: "text" },
  { label: "Đại Diện Bốc Xếp", key: "daidienbocxep", type: "text" },
  { label: "Người Nhận", key: "nguoinhan", type: "text" },
  { label: "Lệnh Xuất Hàng", key: "lenhxuathang", type: "text" },
  { label: "Người Tạo Phiếu", key: "nguoitaophieu", type: "text" },
  // {
  //   label: "Tài Khoản Thiết Bị",
  //   key: "taiKhoanThietBiLogsPXKXN",
  //   type: "text",
  // },
  {
    label: "Người Cập Nhật",
    key: "taiKhoanNguoiDungLogsPXKXN",
    type: "text",
  },
  { label: "Ngày Đồng Bộ", key: "ngayDongBoLogsPXK", type: "date" },
  // { label: "Action", key: "", type: "text" },
  { label: "Trạng Thái", key: "status", type: "text" },
  // { label: "Response", key: null },

  //   { label: "Action", key: "actionLogsPXKXN", type: "text" },
];
